import React from "react";
import "./Steps.css"
import phone from "../static/Phone Mockup.svg"
import patientcircle from "../static/Feature Icon with circle.svg"
import doctorcircle from "../static/Feature Icon with circle.svg"

export default function Steps(){
    return(
        <div className="services-section" id="services">
            <div className="services-container">
                <div className="services-header">
                    <h2>Our Services</h2>
                    <p className="services-subtitle">Comprehensive technology solutions for every need</p>
                </div>
                <div className="services-grid">
                    <div className="service-card training-card">
                        <div className="service-icon">🎓</div>
                        <div className="service-content">
                            <h3>Training Programs</h3>
                            <ul className="service-features">
                                <li>Free college training: Web tech, Cloud, DevOps, Linux</li>
                                <li>Corporate training: Kubernetes, AWS, Azure, GCP</li>
                                <li>Terraform, Ansible, Python programming</li>
                            </ul>
                        </div>
                    </div>
                    <div className="service-card development-card">
                        <div className="service-icon">💻</div>
                        <div className="service-content">
                            <h3>Application Development</h3>
                            <ul className="service-features">
                                <li>Custom web application development</li>
                                <li>AI-powered applications</li>
                                <li>Modern web solutions</li>
                            </ul>
                        </div>
                    </div>
                    <div className="service-card consultation-card">
                        <div className="service-icon">🔧</div>
                        <div className="service-content">
                            <h3>Technical Consultation</h3>
                            <ul className="service-features">
                                <li>DevOps strategy & implementation</li>
                                <li>Multi-cloud solutions (AWS, Azure, GCP)</li>
                                <li>Application architecture & strategy</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}